import { publicRoutes } from "./publicRoutes";
import { privateRoutes } from "./privateRoutes";
import HeaderLayout from "../layouts/HeaderLayout";
import BaseLayout from "../layouts/BaseLayout";
import ProtectPrivateRoute from "./ProtectRoutes/ProtectPrivateRoute";
import Status404 from "../pages/Status/Status404";

const RoutingHandler = [
  {
    path: "",
    element: <BaseLayout />,
    children: [...publicRoutes],
  },
  {
    path: "/",
    element: (
      <ProtectPrivateRoute>
        <HeaderLayout />
      </ProtectPrivateRoute>
    ),
    children: [...privateRoutes],
  },
  {
    path: "*",
    element: <Status404 />,
  },
];

export default RoutingHandler;
